
import { useEffect } from 'react';

import { InterimStates } from "../InterimStates";

import { useQuery, gql } from '@apollo/client';

interface IProps {
    triggerRefetch?: boolean,
    personId: number,
    blockCode: string,
}

const PERSON_BLOCK_ATTENDANCE = gql`
    query Query($userId: Int!, $blockCode: String!) {
        userBlockAttendance(userId: $userId, blockCode: $blockCode)
    }
`;

const PersonBlockAttendance = ({
    personId,
    triggerRefetch,
    blockCode
}: IProps) => {
    const { loading, error, data, refetch } = useQuery(PERSON_BLOCK_ATTENDANCE, {
        variables: {
            userId: personId,
            blockCode,
        }
    });

    useEffect(() => {
        refetch();
      }, [triggerRefetch, refetch]);


    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    return (
        <>
        {Math.round(data.userBlockAttendance * 10000) / 100}%
        </>
    )
}

export { PersonBlockAttendance }
